if($('footer#footer').length){
    $('.footer-bottom').insertAfter('footer#footer').wrap('<div class="underFooter"></div>')
    $('#signature').append('<span class="signatureFirm"> | <a href="https://www.d2solutions.cz/" target="_blank">D2solutions</a> | <a href="https://www.shopcode.cz/" target="_blank">ShopCode</a></span>')
    $('footer#footer .contact-box span.facebook').closest('li').clone().appendTo('.social')
    $('footer#footer .contact-box span.instagram').closest('li').clone().appendTo('.social')
    $('footer#footer .contact-box span.twitter').closest('li').clone().appendTo('.social')
    $('footer#footer .contact-box span.youtube').closest('li').clone().appendTo('.social')
    $('footer#footer .contact-box span.tel').closest('li').clone().appendTo('.customContact')
    $('footer#footer .contact-box span.whatsapp').closest('li').clone().appendTo('.customContact')
    $('footer#footer .contact-box span.mail').closest('li').clone().appendTo('.customContact')


    $('.connection .left').append($('#footer#footer #formNewsletterWidget'))
    $('footer#footer .contact-box span.facebook').closest('li').clone().appendTo('.connection .right ul')
    $('footer#footer .contact-box span.instagram').closest('li').clone().appendTo('.connection .right ul')
    $('footer#footer .contact-box span.twitter').closest('li').clone().appendTo('.connection .right ul')
    $('footer#footer .contact-box span.youtube').closest('li').clone().appendTo('.connection .right ul')
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    })
    
}